import script from "./template_25.vue?vue&type=script&setup=true&lang=js"
export * from "./template_25.vue?vue&type=script&setup=true&lang=js"

import "./template_25.vue?vue&type=style&index=0&id=313e14fe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313e14fe"]])

export default __exports__